import { ReportingView } from '../../components/reporting';
import { useReportingSettings } from '../../state/useReportingSettings';

export interface ReportingViewsProps {
  view: string;
  bookings: any;
  activities: any;
  /** Tournaments incl. live ones (archiveWithLive) — seriespill season fees. */
  archiveWithLive: any;
  effectivePlayerDB: any;
  clubInfo: any;
  bookingConfig: any;
  goHome: () => void;
}

// View-group for the Reporting module (`view === 'reporting'`): the centre's
// monthly settlement basis. Owns the fee-model settings slice so AppShell only
// has to pass the read-only data the ledger is built from.
export function ReportingViews({
  view,
  bookings,
  activities,
  archiveWithLive,
  effectivePlayerDB,
  clubInfo,
  bookingConfig,
  goHome,
}: ReportingViewsProps) {
  const { settings, saveSettings } = useReportingSettings();
  if (view !== 'reporting') return null;
  return (
    <ReportingView
      bookings={bookings || []}
      activities={activities || []}
      tournaments={archiveWithLive || []}
      players={effectivePlayerDB || []}
      clubInfo={clubInfo}
      bookingConfig={bookingConfig}
      settings={settings}
      onSaveSettings={saveSettings}
      onBack={goHome}
    />
  );
}
